import React, { useEffect, useState } from 'react'
import SingleFacilitatorData from '../../components/AssignedFacilitators/SingleFacilitatorData'
import api from '../../utils/api'
import Spinner from "../../common/Spinner/Spinner";
import { toast } from "react-toastify";
import MultipleFacilitatorData from '../../components/AssignedFacilitators/MultipleFacilitatorData';


const AssignedFacilitatorContainer = () => {

    const [singleFacilitator, setSingleFacilitator] = useState(false)
    const [multipleFacilitator, setMultipleFacilitator] = useState(false)
    const [tableData, setTableData] = useState([])
    const [tableDataMultiple, setTableDataMultiple] = useState([])
    const [singleCount, setSingleCount] = useState(0)
    const [multipleCount, setMultipleCount] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [isLoadingContainer, setIsLoadingContainer] = useState(false)



    const onSingleFacilitatorClick = () => {
        setSingleFacilitator(true)
        setMultipleFacilitator(false)
    }

    const onMultipleFacilitatorClick = () => {
        setSingleFacilitator(false)
        setMultipleFacilitator(true)
    }

    // const [count,setCount]=useState(
    //     {
    //         single_user_facilitator:0,
    //         multi_user_facilitator:0
    //     }
    // );

    useEffect(() => {
        getTableData();
    }, [])

    const getTableData = () => {
        setIsLoading(true)
        api.getFacilitatorCount().then((data) => {
            if (data) {
                console.log("Count:", data.data[0])
                setSingleCount(data.data[0].single_facilitator_count)
                setMultipleCount(data.data[0].multiple_facilitator_count)
            }
            else {
                toast("", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
        }).catch((error) => {
            //setIsLoading(false);
            if (error.response.data.detail) {
                toast(String(error.response.data.detail), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else if (error.response.data.message) {
                toast(String(error.response.data.message), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }

        });


        api.getSingleUserFacilitatorData().then((data) => {
            if (data) {
                console.log("SingleUserData:", data.data[0]["single_facilitator_list"])
                setTableData(data.data[0]["single_facilitator_list"])
            }
            else {
                toast("", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }

        }).catch((error) => {
            setIsLoading(false);
            if (error.response.data.detail) {
                toast(String(error.response.data.detail), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else if (error.response.data.message) {
                toast(String(error.response.data.message), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
        });


        api.getMultipleUserFacilitatorData().then((data) => {
            setIsLoading(false)
            if (data) {
                console.log("MultipleUserData:", data.data[0]["multiple_facilitator_list"])
                setTableDataMultiple(data.data[0]["multiple_facilitator_list"])
            }
            else {
                toast("", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
        }).catch((error) => {
            setIsLoading(false);
            if (error.response.data.detail) {
                toast(String(error.response.data.detail), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else if (error.response.data.message) {
                toast(String(error.response.data.message), {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }
            else {
                toast("Internal server error", {
                    autoClose: 5000,
                    type: toast.TYPE.ERROR,
                });
            }

        });


    }


    return (
        <>
            <div>
                <div className={`${isLoading && "set-opacity"}`}>
                    {isLoading && <Spinner className="center-screen" />}
                    <div className="row" style={{ marginTop: "10px" }}>
                        <div className="col-12">
                            <div className="row" style={{ display: "flex", justifyContent: "space-evenly" }}>
                                <div className="col-3" style={{ cursor: "pointer" }} onClick={onSingleFacilitatorClick}>
                                    <div className="facilitator-dashboard-card conv-text-center">
                                        <label className="esp-box-header-title">Single Facilitator</label>
                                        <h5 className="facilitator-count-text">{singleCount}</h5>
                                        <div style={{ clear: "both" }}></div>
                                    </div>
                                </div>
                                <div className="col-3" style={{ cursor: "pointer" }} onClick={onMultipleFacilitatorClick}>
                                    <div className="facilitator-dashboard-card conv-text-center">
                                        <label className="esp-box-header-title">Multiple Facilitator</label>
                                        <h5 className="facilitator-count-text">{multipleCount}</h5>
                                        <div style={{ clear: "both" }}></div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                {
                                    singleFacilitator === true ? <div className="col-12 conv-mt30 service-partner spled-container engagedusers-report">
                                        <h4 className='conv-text-center conv-fontfamily-mont'>Single User Facilitator</h4>
                                        <SingleFacilitatorData
                                            data={tableData} />
                                    </div> : ""
                                }
                                {
                                    multipleFacilitator === true ? <div className="col-12 conv-mt30 service-partner spled-container engagedusers-report">
                                        <h4 className='conv-text-center conv-fontfamily-mont'>Multiple User Facilitator</h4>
                                        <MultipleFacilitatorData
                                            data={tableDataMultiple} />
                                    </div> : ""
                                }

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}

export default AssignedFacilitatorContainer
